export default __webpack_public_path__ + "static/media/CODIGOBOLETA.50c65cf6.png";